module.exports = {
  title: `Honey bee`,
  description: `Just a blog ...`,
  author: `bee`,
  introduction: `Hello.`,
  siteUrl: `https://honey-bee.netlify.app/`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: ``, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/profile.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: 'https-honey-bee-netlify-app', // Your disqus-short-name. check disqus.com.
    utterances: 'shinners1/my-blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'shinners1',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'G-NSLJJZ1QZB', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`

}
